//
//
//
//
//
//

    export default {
        name:'sy-header',
        methods: {
            goBack(){
                
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-header.vue